// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__WTW05","disabled":"FileBtn_disabled__3OxNO","warn":"FileBtn_warn__2ikLF","fade":"FileBtn_fade__QkgE1"};